import React, { useEffect } from "react";

const DisableZoom: React.FC = () => {
	useEffect(() => {
		const handleWheel = (e: WheelEvent) => {
			if (e.ctrlKey) {
				e.preventDefault();
			}
		};

		const handleKeydown = (e: KeyboardEvent) => {
			if (e.ctrlKey && (e.key === "Plus" || e.key === "-" || e.key === "+")) {
				e.preventDefault(); // Prevent zooming with Ctrl + Plus/Minus
			}
		};

		window.addEventListener("wheel", handleWheel, { passive: false });
		window.addEventListener("keydown", handleKeydown, { passive: false });

		return () => {
			window.removeEventListener("wheel", handleWheel);
			window.removeEventListener("keydown", handleKeydown);
		};
	}, []);

	return <div className="d-none">Your React Component Content</div>;
};

export default DisableZoom;
